/**
 *
 * @param key Use with JSON.parse() to replace null-values
 * with undefined to match our schema
 * @param value
 * @returns
 */
export const reviver = (_key, value) => {
  if (value === null) {
    return undefined;
  }
  return value;
};

/**
 * Use with JSON.stringify to replace undefined-values with null
 * so that they are actually written into the JSON-string
 * @param key
 * @param value
 * @returns
 */
export const replacer = (_key, value) => {
  if (value === undefined) {
    return null;
  }
  return value;
};
